module.exports = __webpack_public_path__ + "static/img/bn2.b5c101b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bn2.jpg
// module id = KRuv
// module chunks = 1